<template>
  <transition name="el-zoom-in-center">
    <div class="newA" v-if="loadover">
      <!-- 遍历 -->
      <div v-for="item in info.list" :key="item.id">
        <div>
          <p>{{ item.create_time.slice(8, 10) }}</p>
          <p>{{ item.create_time.slice(0, 7) }}</p>
        </div>
        <el-image
          :src="item.image"
          fit="cover"
          :preview-src-list="[item.image]"
        ></el-image>
        <div>
          <div>
            <h1>
              {{ item.title }}
            </h1>
            <p>
              {{ item.summary }}
            </p>
          </div>
          <p
            @click="toArticel({ cate:item.cate_id, id: item.id })"
            class="a"
          >
            了解详情<i class="el-icon-arrow-right"></i>
          </p>
        </div>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="info.count"
        :page-size="params.limit"
        :current-page="params.page"
        @current-change="setParams"
        prev-text="上一页"
        next-text="下一页"
      >
      </el-pagination>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "newA",
  data() {
    return {
      loadover: false,
      info: {},
      list: [],
      pageCount: 0,
      params: {
        limit: 3,
        page: 1,
      },
    };
  },
  computed: mapGetters(["meanCenterObj", "pageCate"]),
  created() {
    this.$nextTick(() => {
      this.getList();
    });
  },
  methods: {
    ...mapActions(["toArticel"]),
    getList() {
      this.loadover = false;
      this.$api.CATE(this.meanCenterObj._child[0].id, this.params).then((res) => {
        // this.$public_data.imageURL(res.list).then(() => {
          Object.assign(this.info, res);
          this.loadover = true;
        // });
      });
    },
    setParams(e) {
      this.params.page = e;
      console.log(e, 999);
      this.getList();
    },
  },
};
</script>

<style scoped lang='less'>
.a {
  cursor: pointer;
}
.newA {
  > div:not(:last-child) {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    margin: 2.08vw auto;
    padding-bottom: 2.08vw;
    border-bottom: 1px solid #d7d7d7;
    > div:first-child {
      color: #999;
      > p:first-child {
        font-size: 1.875vw;
        font-weight: bold;
        width: 5.104vw;
        border-bottom: 1px solid #999;
        text-align: center;
        margin-bottom:0.2604vw;
      }
      width:7.1875vw;
      height: 6.302vw;
      background-image: url("../../assets/image/zrili.png");
      background-size:7.1875vw 6.302vw;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;
    }
    > .el-image {
      width: 20.8vw;
      height: 12.291vw;
    }
    > div:last-child {
      width: 45.208vw;
      height: 11.25vw;
      display: flex;
      flex-flow: column nowrap;
      justify-content: space-between;
      > div {
        >h1{
          margin-bottom:1vw;
        }
        > p {
          font-size:  0.93vw;
        }
        + p {
          font-size: 0.83vw;
        }
      }
    }
  }
  .el-pagination {
    width: 31.25vw;
    margin: 3.1vw auto 0;
    text-align: center;
    height: 3.33vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/news/newA.vue